// components
import GridPageAbstract from '../../GridPageAbstract';
import { CoinBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class PartnerHasCoinsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'partnerHasCoins';
        this.Server = this.props.context.getState().server.partnerHasCoins;

        this.headerStartIcon = CoinBulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.searchFields = [
            'coin.name',
            'partner.name'
        ];

        this.hiddenColumns = config?.hiddenColumns?.partnerHasCoins || [];

        this.Head = [
            {
                id: 'coinId',
                object: 'coin',
                display: 'name',
                label: 'coin',
                alignRight: false,
                cell: 'Select',
                from: 'coins',
                filterCell: 'Context',
                filterBy: 'coins'
            },
            {
                id: 'partner',
                object: 'partner',
                display: 'name',
                label: 'partner',
                alignRight: false,
                cell: 'Select',
                from: 'partners',
                filterCell: 'Context',
                filterBy: 'partners'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
